module.exports = __webpack_public_path__ + "static/media/sec6_banner_wizmall.494a1ab1.png";